import React, { useState } from "react";
import { TreeNodeModel, EntityType } from "./types";

interface Props {
  node: TreeNodeModel;
  onSelect: (n: TreeNodeModel) => void;
  onAdd: (parent: TreeNodeModel) => void;
  onDelete: (node: TreeNodeModel) => void;
  readonly?: boolean;
  isClientExistent?: boolean;
  isViewer?: boolean;
}

const nextLabel: Record<EntityType, EntityType | null> = {
  CLIENT: "CORP_CONTRACT",
  CORP_CONTRACT: "DIV_CONTRACT",
  DIV_CONTRACT: "STORE_CONTRACT",
  STORE_CONTRACT: "DEVICE_CONTRACT",
  DEVICE_CONTRACT: null
};

const getNextText = (type: EntityType): string => {
  switch (type) {
    case "CLIENT":
      return "Corporación";
    case "CORP_CONTRACT":
      return "División";
    case "DIV_CONTRACT":
      return "Tienda";
    case "STORE_CONTRACT":
      return "Terminal";
    default:
      return "";
  }
};

export const TreeNode: React.FC<Props> = ({
  node,
  onSelect,
  onAdd,
  onDelete,
  readonly,
  isClientExistent,
  isViewer
}) => {
  const [open, setOpen] = useState(true);
  const next = nextLabel[node.type];

  // 🔥 Regla: solo permitir borrar nodos nuevos cuando el cliente es existente
  const canDelete =
    !readonly &&
    node.type !== "CLIENT" && !node.isExistent;



  const hasCorporation = node.children.some(
    child => child.type === "CORP_CONTRACT"
  );

  const canAdd =
    !readonly &&
    node.saved &&
    next &&
    (
      (node.type === "CLIENT" && !hasCorporation) ||
      (node.type !== "CLIENT" &&
        (!isClientExistent ||
          next === "STORE_CONTRACT" ||
          next === "DEVICE_CONTRACT"))
    );



  const name = node.name + " " + (node.isExistent ? "" : "(Nuevo)") || "Sin nombre";

  return (
    <div className="ms-3 mt-2">
      {/* Nodo */}
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <button
            className="btn btn-sm px-1"
            onClick={() => setOpen(!open)}
          >
            {open ? "▼" : "▶"}
          </button>

          <span
            className="fw-bold ms-1 cursor-pointer"
            onClick={() => onSelect(node)}
          >
            {name}
          </span>
        </div>

        {/* Eliminar */}
        {canDelete && (
          <button
            className="btn btn-sm text-danger p-0"
            title="Eliminar"
            onClick={() => onDelete(node)}
          >
            <i className="bi bi-trash"></i>
          </button>
        )}
      </div>

      {open && (
        <div className="ms-4">
          {/* Hijos */}
          {node.children.map(child => (
            <TreeNode
              key={child.id}
              node={child}
              onSelect={onSelect}
              onAdd={onAdd}
              onDelete={onDelete}
              readonly={readonly}
              isClientExistent={isClientExistent}
            />
          ))}

          {/* Agregar siguiente nivel */}
          {canAdd && (
            <div className="mt-1">
              <button
                className="btn btn-sm p-0 text-muted"
                onClick={() => onAdd(node)}
              >
                + Agregar {getNextText(node.type)}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
